import React from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material'

import { Button, Icon, IconButton, TextField } from '~components/internal'

import './RenameDialog.scss'

interface RenameDialogProps {
  open: boolean
  title: string
  value: string
  onChange: (value: string) => void
  onSave: () => void
  onClose: () => void
  isSaving?: boolean
  maxLength?: number
}

const RenameDialog: React.FC<RenameDialogProps> = ({
  open,
  title,
  value,
  onChange,
  onSave,
  onClose,
  isSaving = false,
  maxLength,
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth='xs'>
    <DialogTitle className='rename-dialog__title'>
      {title}
      <Tooltip title='Close'>
        <span>
          <IconButton size='small' aria-label='Close' onClick={onClose} disabled={isSaving}>
            <Icon name='close' fontSize='small' />
          </IconButton>
        </span>
      </Tooltip>
    </DialogTitle>
    <DialogContent className='rename-dialog__content'>
      <TextField
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !isSaving) onSave()
        }}
        inputProps={maxLength ? { maxLength } : undefined}
        autoFocus
      />
    </DialogContent>
    <DialogActions className='rename-dialog__actions'>
      <Button variant='outlined' onClick={onClose} disabled={isSaving}>
        Cancel
      </Button>
      <Button onClick={onSave} disabled={isSaving}>
        Save
      </Button>
    </DialogActions>
  </Dialog>
)

export default RenameDialog
